import { useParams } from "react-router";
import { RezerwaContext } from "../../context/rezerwaContext";
import { useContext } from "react";
import { Spin, Alert } from "antd";
import TransferStage from "./components/TransfersStage";

const Rezerwa = () => {
    const { rezerwaid } = useParams();
    const { rezerwa } = useContext(RezerwaContext);

    const isLoading = rezerwa.rezerwa_loading;
    const hasData = rezerwa?.rezerwa_data; // Check if data exists
    return (
        <>
            {isLoading ? (
                <Spin spinning={true}>
                    <div style={{ height: "100vh" }}></div>
                </Spin>
            ) : hasData ? (
                <TransferStage/>
            ) : (
                <Alert
                    message="Brak danych"
                    description="Nie udało się załadować danych rezerwy. Sprawdź ID lub spróbuj ponownie."
                    type="error"
                    showIcon
                />
            )}
        </>
    );
};

export default Rezerwa;
